import { seonStreamLabel, seonStreamSessionTimeoutMs, seonStreamStorageKey } from './constants'
import { loadSeonStreamSdk } from './loaders'

let seonStream = null
let streamStartPromise = null
let currentStreamId = null

const getSeonStream = SeonStream => {
  if (!seonStream) {
    seonStream = new SeonStream({ sessionTimeoutMs: seonStreamSessionTimeoutMs, storageKey: seonStreamStorageKey })
  }

  return seonStream
}

const startNewStream = async getAuthData => {
  try {
    const [authData, { default: SeonStream }] = await Promise.all([getAuthData(), loadSeonStreamSdk()])

    if (!authData) return null

    const stream = getSeonStream(SeonStream)

    stream.setConfig({ authData })

    const { streamId } = await stream.startStream({ label: seonStreamLabel })

    currentStreamId = streamId

    return streamId
  } catch {
    streamStartPromise = null

    return null
  }
}

export const preloadSeonStream = async () => {
  try {
    await loadSeonStreamSdk()
  } catch {
    return null
  }
}

export const getSeonStreamId = () => currentStreamId

export const ensureSeonStream = getAuthData => {
  if (!streamStartPromise) streamStartPromise = startNewStream(getAuthData)

  return streamStartPromise
}

export const getSeonStreamStorageEntries = () => {
  return Object.entries(localStorage).filter(([key]) => key.startsWith(seonStreamStorageKey))
}

export const restoreSeonStreamStorageEntries = entries => {
  entries.forEach(([key, value]) => localStorage.setItem(key, value))
}
